import Svg, { Path } from "react-native-svg";
import type { SvgProps } from "react-native-svg";
import { memo } from "react";
const SvgCircleInfoSolid = (props: SvgProps) => <Svg xmlns="http://www.w3.org/2000/svg" width={30} height={31} fill="none" viewBox="0 0 30 31" {...props}><Path fill="currentColor" d="M15 30.5c-8.285 0-15-6.715-15-15S6.715.5 15 .5s15 6.715 15 15-6.715 15-15 15Zm-2.333-10v4.667h4.666V20.5h-4.666Zm0-15.333v12.666h4.666V5.167h-4.666Z" /></Svg>;
const Memo = memo(SvgCircleInfoSolid);
export default Memo;